import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import { PaymentQueryParams } from '@tsin-core/models/payment.model';

const PAYMENT_URL = `${environment.apiUrl}/payment`;

@Injectable({
  providedIn: 'root'
})
export class PaymentHttpService {
  http: HttpClient = inject(HttpClient);

  getPayments(query: PaymentQueryParams = {}) {
    let params = new HttpParams();
    if (query.examType) { params = params.set('examType', query.examType); }
    if (query.status) { params = params.set('status', query.status); }
    if (query.paymentGateway) { params = params.set('paymentGateway', query.paymentGateway); }
    if (query.payerEmail) { params = params.set('payerEmail', query.payerEmail); }
    if (query.userId) { params = params.set('userId', query.userId); }
    return this.http.get<any[]>(PAYMENT_URL, { params });
  }
}
